// Fix this file, do not use any as the type
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios'

import { Get } from 'config/apiServiceConfig'
import { getNeededAttributeFromQueryObj } from 'utils/queryObj'

const { REACT_APP_BASE_URL_API } = process.env
const baseUrl = REACT_APP_BASE_URL_API

export const getRakList = (params = {}): any => axios.get(`${baseUrl}/api/racks`, { params })

export const getRackListByLocationId = (locationId: any, params = {}): any =>
  axios.get(`${baseUrl}/api/racks/v2/${locationId}`, {
    params: getNeededAttributeFromQueryObj(params),
  })

export const getRacksExport = (locationId: any, queryParams: any): any =>
  axios.get(`${baseUrl}/api/racks/${locationId}/export`, {
    params: getNeededAttributeFromQueryObj(queryParams),
  })

export const getRackCsvTemplate = (): any => axios.get(`${baseUrl}/api/racks/csv/template`)

export const postRackImport = (data: any, config: any): any =>
  axios.post(`${baseUrl}/api/racks/import`, data, config)

export const putActiveDeactivateRackItem = (rackId: any): any =>
  axios.put(`${baseUrl}/api/racks/active-toggle/${rackId}`)

export const getSingleRackDetail = (rackId: any): any =>
  axios.get(`${baseUrl}/api/racks/single/${rackId}`)

export const putSingleRackDetail = (locationId: any, data: any): any =>
  axios.put(`${baseUrl}/api/racks/single/${locationId}`, data)

export const getRackStorage = (params = {}): any =>
  axios.get(`${baseUrl}/api/racks/storage`, { params })

export const getLocationAllRack = (params: any): any =>
  axios.get(`${baseUrl}/api/location`, { params })

export const getListLocationOfByLocationType = (locationType: any): any =>
  axios.get(`${baseUrl}/api/locations/${locationType}`)

export const postNewRack = (locationId: any, formData: any): any =>
  axios.post(`${baseUrl}/api/racks/${locationId}`, formData)

export const putRack = (locationId: any, formData: any): any =>
  axios.put(`${baseUrl}/api/racks/${locationId}`, formData)

export const getLocationOfHub_Rak = (): any => axios.get(`${baseUrl}/api/locations/hub`)

export const getLocationOfWarehouse_Rak = (): any => axios.get(`${baseUrl}/api/locations/warehouse`)

export const postUpdateRakInLocation_Rak = (location_id: any, data: any): any =>
  axios.post(`${baseUrl}/api/location/${location_id}/racks`, data)

export const getRakFromLocationID_Rak = (location_id: any, query = ''): any =>
  axios.get(`${baseUrl}/api/racks/${location_id}${query}`)

export const putRakNumberAndPosition = (location_id: any, data: any): any =>
  axios.put(`${baseUrl}/api/racks/${location_id}`, data)

export const deleteRack = (locationId: any, params: any): any =>
  axios.delete(`${baseUrl}/api/racks/${locationId}`, { params })

export const postNewRak = (location_id: any, data: any): any =>
  axios.post(`${baseUrl}/api/racks/${location_id}`, data)

export const confirmSingleSloc = (id: any, params: any): any =>
  Get({
    url: '/api/ims/:version/inventories/detail/:id/confirm-single-sloc',
    version: 'v2',
    urlParams: { id },
    params,
  })

// api lama
export const getRakList_Rak = (query = ''): any => axios.get(`${baseUrl}/api/racks${query}`)

export const getLocationAll_Rak = (query = ''): any => axios.get(`${baseUrl}/api/location${query}`)

export const deleteRak = (location_id: any, rak_id: any): any =>
  axios.delete(`${baseUrl}/api/racks/${location_id}?id=${rak_id}`)
